<template>
  <div>
    <div align="right" style="margin: 10px">
      <Button color="primary" @click="add">新增</Button>
      <Button color="green" @click="openDepreciate">折旧计提</Button>
    </div>
    <Table :datas="cardList" :border="true" :loading="loading">
      <TableItem title="编码" prop="code" :width="150"></TableItem>
      <TableItem title="资产名称" prop="name"></TableItem>
      <TableItem title="类别">
        <template slot-scope="{data}">
          {{ categoryName(data.categoryId) }}
        </template>
      </TableItem>
      <TableItem title="原值" align="right">
        <template slot-scope="{data}">
          {{ data.originalValue | numFormat }}
        </template>
      </TableItem>
      <TableItem title="累计折旧" align="right">
        <template slot-scope="{data}">
          {{ data.accumulatedDepreciation | numFormat }}
        </template>
      </TableItem>
      <TableItem title="净值" align="right">
        <template slot-scope="{data}">
          {{ data.netValue | numFormat }}
        </template>
      </TableItem>
      <TableItem title="开始使用日期" :width="120">
        <template slot-scope="{data}">
          {{ dateFormat(data.startDate) }}
        </template>
      </TableItem>
      <TableItem title="状态" :width="80" align="center">
        <template slot-scope="{data}">
          {{ data.status === 2 ? '已清理' : '在用' }}
        </template>
      </TableItem>
      <TableItem title="操作" :width="140">
        <div class="actions" slot-scope="{data}">
          <span @click="edit(data)" v-if="data.status !== 2">编辑</span>
          <span @click="dispose(data)" v-if="data.status !== 2">清理</span>
          <span @click="remove(data)" v-if="data.status !== 2">删除</span>
        </div>
      </TableItem>
    </Table>

    <!--新增/编辑弹窗-->
    <Modal v-model="showForm" type="drawer-right" hasCloseIcon>
      <div slot="header">固定资产</div>
      <Form ref="form" v-width="420" :labelWidth="110" :model="form" :rules="validationRules">
        <FormItem label="资产名称" prop="name">
          <input type="text" v-model="form.name">
        </FormItem>
        <FormItem label="资产类别" prop="categoryId">
          <Select v-model="form.categoryId" :datas="categoryList" keyName="id" titleName="name"
                  @change="categoryChange"></Select>
        </FormItem>
        <FormItem label="原值" prop="originalValue">
          <NumberInput :min="0" v-model="form.originalValue"></NumberInput>
        </FormItem>
        <FormItem label="净残值" prop="netSalvageValue">
          <NumberInput :min="0" v-model="form.netSalvageValue"></NumberInput>
        </FormItem>
        <FormItem label="使用月数" prop="useMonths">
          <NumberInput :min="1" v-model="form.useMonths"></NumberInput>
        </FormItem>
        <FormItem label="开始使用日期" prop="startDate">
          <DatePicker type="date" v-model="form.startDate" format="YYYY-MM-DD"></DatePicker>
        </FormItem>
      </Form>
      <div class="text-center">
        <Button color="green" @click="submit" :loading="loading">{{form.id?'更新':'保存'}}</Button>
        <Button @click="showForm=false" :loading="loading">取消</Button>
      </div>
    </Modal>

    <!--折旧计提：选择期间-->
    <Modal v-model="showDepMonth" :hasCloseIcon="true" :closeOnMask="false" :middle="true">
      <div slot="header">折旧计提</div>
      <div class="text-center margin">
        <DatePicker type="month" v-model="depMonth" format="YYYY-MM"></DatePicker>
      </div>
      <div class="text-center">
        <Button color="primary" @click="previewDepreciate" :loading="loading">预览分录</Button>
      </div>
    </Modal>

    <!--折旧计提：分录预览-->
    <Modal v-model="showDepPreview" :hasCloseIcon="false" :closeOnMask="false" :middle="true">
      <div slot="header">折旧计提预览（{{depYear}}年{{depMonthNum}}月）</div>
      <div style="max-height: 400px; overflow: auto;">
        <table class="dep-table" v-if="depLines.length">
          <thead>
          <tr>
            <th>摘要</th>
            <th>科目</th>
            <th>借方</th>
            <th>贷方</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(line, index) in depLines" :key="index">
            <td>{{ line.summary }}</td>
            <td>{{ line.subjectName }}</td>
            <td align="right">{{ line.jie | numFormat }}</td>
            <td align="right">{{ line.dai | numFormat }}</td>
          </tr>
          </tbody>
        </table>
        <div class="text-center margin" v-else>当前期间没有需要计提折旧的资产！</div>
      </div>
      <div class="text-center">
        <Button color="green" @click="doDepreciate" :loading="loading" v-if="depLines.length">确认计提</Button>
        <Button @click="showDepPreview=false">取消</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import moment from 'moment';

const emptyForm = {
  name: '',
  categoryId: null,
  originalValue: null,
  netSalvageValue: 0,
  useMonths: null,
  startDate: null,
  method: 1
};

export default {
  name: "Assets",
  data() {
    return {
      cardList: [],
      categoryList: [],
      form: Object.assign({}, emptyForm),
      validationRules: {
        required: ['name', 'categoryId', 'originalValue', 'useMonths']
      },
      showForm: false,
      showDepMonth: false,
      showDepPreview: false,
      depMonth: null,
      depYear: null,
      depMonthNum: null,
      depLines: [],
      loading: false
    }
  },
  methods: {
    loadList() {
      this.loading = true;
      Promise.all([
        this.$api.assets.card.list(),
        this.$api.assets.category.list()
      ]).then((results) => {
        this.cardList = results[0].data || [];
        this.categoryList = results[1].data || [];
      }).finally(() => this.loading = false);
    },
    categoryName(categoryId) {
      let category = this.categoryList.find(val => val.id === categoryId);
      return category ? category.name : '-';
    },
    dateFormat(val) {
      return val ? moment(val).format('YYYY-MM-DD') : '';
    },
    categoryChange(value) {
      if (value) {
        let category = this.categoryList.find(val => val.id === value);
        if (category && category.lifeMonths) {
          this.form.useMonths = category.lifeMonths;
        }
      }
    },
    add() {
      this.form = Object.assign({}, emptyForm);
      this.showForm = true;
    },
    edit(data) {
      this.form = Object.assign({}, data);
      this.showForm = true;
    },
    submit() {
      let validResult = this.$refs.form.valid();
      if (validResult.result) {
        this.loading = true;
        let data = Object.assign({}, this.form);
        if (data.startDate) {
          data.startDate = moment(data.startDate).format('YYYY-MM-DD');
        }
        this.$api.assets.card[data.id ? 'update' : 'save'](data).then(() => {
          this.$Message('保存成功~');
          this.showForm = false;
          this.loadList();
        }).catch(() => {
        }).finally(() => this.loading = false);
      }
    },
    dispose(data) {
      this.$Confirm(`确认清理资产[${data.name}]？将生成处置凭证，操作不可恢复！`).then(() => {
        this.loading = true;
        this.$api.assets.card.dispose(data.id).then(() => {
          this.$Message('清理成功~');
          this.loadList();
        }).catch(() => {
        }).finally(() => this.loading = false);
      })
    },
    remove(data) {
      this.$Confirm("确认删除?").then(() => {
        this.$api.assets.card.delete(data.id).then(() => {
          this.loadList();
        })
      })
    },
    openDepreciate() {
      this.depMonth = moment().format('YYYY-MM');
      this.depLines = [];
      this.showDepMonth = true;
    },
    previewDepreciate() {
      if (!this.depMonth) {
        this.$Message('请选择计提期间！');
        return;
      }
      let date = moment(this.depMonth);
      this.depYear = date.year();
      this.depMonthNum = date.month() + 1;
      this.loading = true;
      this.$api.assets.card.preview({year: this.depYear, month: this.depMonthNum}).then(({data}) => {
        this.depLines = data || [];
        this.showDepMonth = false;
        this.showDepPreview = true;
      }).catch(() => {
      }).finally(() => this.loading = false);
    },
    doDepreciate() {
      this.loading = true;
      this.$api.assets.card.depreciate({year: this.depYear, month: this.depMonthNum}).then(() => {
        this.$Message('折旧计提成功~');
        this.showDepPreview = false;
        this.loadList();
      }).catch(() => {
      }).finally(() => this.loading = false);
    }
  },
  mounted() {
    this.loadList();
  }
}
</script>

<style lang="less" scoped>
.dep-table {
  width: 100%;
  border-collapse: collapse;

  th, td {
    border-bottom: 1px solid #eee;
    padding: 8px 10px;
  }

  th {
    background: #f8f8f8;
  }
}
</style>
